// skipcq: JS-W1028
import React from 'react';
// Material UI
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';

function ButtonHeader(props) {
  return (
    <Container
      maxWidth={props.fullWidth ? false : 'lg'}
      disableGutters={Boolean(props.fullWidth)}
      sx={
        props.sticky
          ? {
              position: 'sticky',
              // Align with dense DashboardLayout AppBar / main Toolbar spacer (48px)
              top: '48px',
              zIndex: (theme) => theme.zIndex.appBar - 1,
              bgcolor: 'background.paper',
              borderBottom: '1px solid',
              borderColor: 'divider',
              // Keeps outlined search labels and controls clear of the fixed app bar edge
              pt: 1.5,
              pb: 0.5,
            }
          : undefined
      }
    >
      <Grid container spacing={props.dense ? 0 : 2} sx={{
        p: props.dense ? 0 : 2
      }}>
        <Grid
          container
          spacing={props.dense ? 1 : 2}
          item
          xs={12}
          sx={{
            justifyContent: 'space-around',
            alignItems: "center"
          }}>
          {props.children}
        </Grid>
      </Grid>
    </Container>
  );
}

export default ButtonHeader;
